export const GET_ORDERS = "GET_ORDERS";
export const GET_ORDERS_BULK = "GET_ORDERS_BULK";
export const FILTER_ORDERS = "FILTER_ORDERS";
export const GET_DATA_QUALITY_SAP_ORDERS = "GET_DATA_QUALITY_SAP_ORDERS";
export const GET_DATA_QUALITY_SAP_ORDERS_BULK =
  "GET_DATA_QUALITY_SAP_ORDERS_BULK";
export const GET_HWS_SNS_TRAIL = "GET_HWS_SNS_TRAIL";
export const GET_HWS_SNS_TRAIL_BULK = "GET_HWS_SNS_TRAIL_BULK";
export const FILTER_DATA_QUALITY_SAP_ORDERS = "FILTER_DATA_QUALITY_SAP_ORDERS";
export const FILTER_HWS_SNS_TRAIL = "FILTER_DHWS_SNS_TRAIL";
export const FILTER_SERIAL_NUMBERS = "FILTER_SERIAL_NUMBERS";
export const GET_SERIAL_NUMBERS = "GET_SERIAL_NUMBERS";
export const SORT_SERIAL_NUMBERS = "SORT_SERIAL_NUMBERS";
export const SORT_ORDERS = "SORT_ORDERS";
export const SORT_DATA_QUALITY_SAP_ORDERS = "SORT_DATA_QUALITY_SAP_ORDERS";
export const SORT_HWS_SNS_TRAIL = "SORT_HWS_SNS_TRAIL";
export const CALL_MATERIAL_SWAP = "CALL_MATERIAL_SWAP";
export const CALL_HWS_SWAP = "CALL_HWS_SWAP";
export const CHECK_HWS_SWAP = "CHECK_HWS_SWAP";
export const CLEAN_API_RESPONSE = "CLEAN_API_RESPONSE";
export const ADD_HWS_SNS_TRAIL_OUT = "ADD_HWS_SNS_TRAIL_OUT";
export const GET_BULK_REPORT = "GET_BULK_REPORT";
export const SORT_BULK_EXPORT = "SORT_BULK_EXPORT";
export const FILTER_BULK_REPORT = "FILTER_BULK_REPORT";
export const GET_MISSING_SNS_STATUS = "GET_MISSING_SNS_STATUS";
export const GET_MISSING_SNS_STATUS_BULK = "GET_MISSING_SNS_STATUS_BULK";
export const SORT_MISSING_SNS_STATUS = "SORT_MISSING_SNS_STATUS";
export const FILTER_MISSING_SNS_STATUS = "FILTER_MISSING_SNS_STATUS";
export const ACCESS_REQUEST = "ACCESS_REQUEST";
export const APP_MONITORING = "APP_MONITORING";
export const GET_MONITORING = "GET_MONITORING";
export const GET_SFDC_SYNCHRONIZER_MONITORING =
  "GET_SFDC_SYNCHRONIZER_MONITORING";
export const GET_SFDC_SYNCHRONIZER_MONITORING_BULK =
  "GET_SFDC_SYNCHRONIZER_MONITORING_BULK";
export const FILTER_SFDC_SYNCHRONIZER_MONITORING =
  "FILTER_SFDC_SYNCHRONIZER_MONITORING";
export const TRIGGER_SFDC_SYNC = "TRIGGER_SFDC_SYNC";

export function filterOrders(filterParameters) {
  console.log("Action FILTER_ORDERS", filterParameters);
  return { type: FILTER_ORDERS, data: filterParameters };
}

export function getOrders(queryParameters) {
  console.log("Action GET_ORDERS", queryParameters);
  return { type: GET_ORDERS, data: queryParameters };
}
export function getOrdersBulk(queryParameters) {
  console.log("Action GET_ORDERS_BULK", queryParameters);
  return { type: GET_ORDERS_BULK, data: queryParameters };
}
export function getHwsSnTrail(queryParameters) {
  console.log("Action GET_HWS_SNS_TRAIL", queryParameters);
  queryParameters.limit = 100;
  return { type: GET_HWS_SNS_TRAIL, data: queryParameters };
}

export function getHwsSnTrailsBulk(queryParameters) {
  console.log("Action GET_HWS_SNS_TRAIL_BULK", queryParameters);
  return { type: GET_HWS_SNS_TRAIL_BULK, data: queryParameters };
}

export function filterHwsSnTrail(filterParameters) {
  console.log("Action FILTER_HWS_SNS_TRAIL", filterParameters);
  return { type: FILTER_HWS_SNS_TRAIL, data: filterParameters };
}

export function sortHwsSnTrail(sortParameter, direction) {
  console.log("Action SORT_HWS_SNS_TRAIL");
  return { type: SORT_HWS_SNS_TRAIL, data: { sortParameter, direction } };
}

export function filterDataQualitySapOrders(filterParameters) {
  console.log("Action FILTER_DATA_QUALITY_SAP_ORDERS", filterParameters);
  return { type: FILTER_DATA_QUALITY_SAP_ORDERS, data: filterParameters };
}

export function getDataQualitySapOrders(queryParameters) {
  console.log("Action GET_DATA_QUALITY_SAP_ORDERS", queryParameters);
  return { type: GET_DATA_QUALITY_SAP_ORDERS, data: queryParameters };
}

export function getMissingSnsStatusBulk(queryParameters) {
  console.log("Action GET_MISSING_SNS_STATUS_BULK", queryParameters);
  return { type: GET_MISSING_SNS_STATUS_BULK, data: queryParameters };
}

export function getMissingSnsStatus(queryParameters) {
  console.log("Action GET_MISSING_SNS_STATUS", queryParameters);
  return { type: GET_MISSING_SNS_STATUS, data: queryParameters };
}

export function getDataQualitySapOrdersBulk(queryParameters) {
  console.log("Action GET_DATA_QUALITY_SAP_ORDERS_BULK", queryParameters);
  return { type: GET_DATA_QUALITY_SAP_ORDERS_BULK, data: queryParameters };
}

export function sortSerialNumbers(sortParameter, direction) {
  console.log("Action SORT_SERIAL_NUMBERS");
  return { type: SORT_SERIAL_NUMBERS, data: { sortParameter, direction } };
}

export function sortOrders(sortParameter, direction) {
  console.log("Action SORT_ORDERS");
  return { type: SORT_ORDERS, data: { sortParameter, direction } };
}

export function sortDataQualitySapOrders(sortParameter, direction) {
  console.log("Action SORT_DATA_QUALITY_SAP_ORDERS");
  return {
    type: SORT_DATA_QUALITY_SAP_ORDERS,
    data: { sortParameter, direction },
  };
}
export function sortMissingSnsStatus(sortParameter, direction) {
  console.log("Action SORT_MISSING_SNS_STATUS");
  return { type: SORT_MISSING_SNS_STATUS, data: { sortParameter, direction } };
}

export function filterMissingSnsStatus(filterParameters) {
  console.log("Action FILTER_MISSING_SNS_STATUS", filterParameters);
  return { type: FILTER_MISSING_SNS_STATUS, data: filterParameters };
}
export function getSerialNumbers(queryParameters) {
  console.log("Action GET_SERIAL_NUMBERS", queryParameters);
  return { type: GET_SERIAL_NUMBERS, data: queryParameters };
}

export function filterSerialNumbers(filterParameters) {
  console.log("Action FILTER_SERIAL_NUMBERS", filterParameters);
  return { type: FILTER_SERIAL_NUMBERS, data: filterParameters };
}

export function callMaterialSwap(materialSwapSns) {
  console.log("Action CALL_MATERIAL_SWAP", materialSwapSns);
  return { type: CALL_MATERIAL_SWAP, materialSwapSns };
}

export function callHwsSwap(hwsSwapSns) {
  console.log("Action CALL_HWS_SWAP", hwsSwapSns);
  return { type: CALL_HWS_SWAP, hwsSwapSns };
}

export function checkHwsSwap(hwsSwapSns) {
  console.log("Action CHECK_HWS_SWAP", hwsSwapSns);
  return { type: CHECK_HWS_SWAP, hwsSwapSns };
}

export function cleanApiResponse() {
  console.log("Action CLEAN_API_RESPONSE");
  return { type: CLEAN_API_RESPONSE };
}
export function addHwsSnsTrailOut(hwsSnTrailOut) {
  console.log("Action ADD_HWS_SNS_TRAIL_OUT");
  return { type: ADD_HWS_SNS_TRAIL_OUT, hwsSnTrailOut };
}

export function getBulkReport(parameter) {
  console.log("Action GET_BULK_REPORT", parameter);
  return { type: GET_BULK_REPORT, data: parameter };
}

export function sortBulkExports(sortParameter, direction) {
  console.log("Action SORT_BULK_EXPORT", sortParameter, direction);
  return { type: SORT_BULK_EXPORT, data: { sortParameter, direction } };
}

export function filterBulkReport(filterObject) {
  console.log("Action FILTER_BULK_REPORT", filterObject);
  return { type: FILTER_BULK_REPORT, data: filterObject };
}

export function accessRequest(parameter) {
  console.log("Action ACCESS_REQUEST", parameter);
  return { type: ACCESS_REQUEST, data: parameter };
}
export function appMonitoring(metric, event_type) {
  console.log("Action APP_MONITORING", metric);
  return { type: APP_MONITORING, data: metric, event_type: event_type };
}

export function getMonitoring(parameter) {
  console.log("Action GET_MONITORING", parameter);
  return { type: GET_MONITORING, data: parameter };
}

export function getSfdcSynchronizerMonitoring(queryParameters) {
  console.log("Action GET_SFDC_SYNCHRONIZER_MONITORING", queryParameters);
  return { type: GET_SFDC_SYNCHRONIZER_MONITORING, data: queryParameters };
}

export function getSfdcSynchronizerMonitoringBulk(queryParameters) {
  console.log("Action GET_SFDC_SYNCHRONIZER_MONITORING_BULK", queryParameters);
  return { type: GET_SFDC_SYNCHRONIZER_MONITORING_BULK, data: queryParameters };
}

export function filterSfdcSynchronizerMonitoring(filterParameters) {
  console.log("Action FILTER_SFDC_SYNCHRONIZER_MONITORING", filterParameters);
  return { type: FILTER_SFDC_SYNCHRONIZER_MONITORING, data: filterParameters };
}

export function triggerSfdcSync(elementId, detailType, objectType) {
  console.log("Action TRIGGER_SFDC_SYNC", elementId, detailType, objectType);
  return {
    type: TRIGGER_SFDC_SYNC,
    data: {
      element_id: elementId,
      detail_type: detailType,
      object_type: objectType,
    },
  };
}

export const GET_ATHENA_DATABASES = "GET_ATHENA_DATABASES";
export const GET_ATHENA_TABLES = "GET_ATHENA_TABLES";
export const GET_ATHENA_COLUMNS = "GET_ATHENA_COLUMNS";
export const START_ATHENA_QUERY = "START_ATHENA_QUERY";
export const POLL_ATHENA_QUERY = "POLL_ATHENA_QUERY";
export const GET_ATHENA_HISTORY = "GET_ATHENA_HISTORY";
export const CLEAN_ATHENA_QUERY = "CLEAN_ATHENA_QUERY";

export function getAthenaDatabases() {
  console.log("Action GET_ATHENA_DATABASES");
  return { type: GET_ATHENA_DATABASES };
}

export function getAthenaTables(database) {
  console.log("Action GET_ATHENA_TABLES", database);
  return { type: GET_ATHENA_TABLES, data: { database } };
}

export function getAthenaColumns(database, table) {
  console.log("Action GET_ATHENA_COLUMNS", database, table);
  return { type: GET_ATHENA_COLUMNS, data: { database, table } };
}

export function startAthenaQuery(queryParameters) {
  console.log("Action START_ATHENA_QUERY", queryParameters);
  return { type: START_ATHENA_QUERY, data: queryParameters };
}

export function pollAthenaQuery(queryExecutionId, requestUser) {
  console.log("Action POLL_ATHENA_QUERY", queryExecutionId);
  return {
    type: POLL_ATHENA_QUERY,
    data: { query_execution_id: queryExecutionId, request_user: requestUser },
  };
}

export function getAthenaHistory(requestUser) {
  console.log("Action GET_ATHENA_HISTORY", requestUser);
  return { type: GET_ATHENA_HISTORY, data: { request_user: requestUser } };
}

export function cleanAthenaQuery() {
  console.log("Action CLEAN_ATHENA_QUERY");
  return { type: CLEAN_ATHENA_QUERY };
}
